<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct1" id="pz9-1"><a href="#/contents#conp1" id="tocp1"><i>Part 1</i></a></h1>
<p class="txd" id="pz9-2"><i>Love is the child of freedom, never that of domination.</i></p>
<p class="txdr" id="pz9-3">—E<span class="smallcaps">RICH</span> F<span class="smallcaps">ROMM </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?316aaffe